import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const DIALOG_BREAKPOINTS = { '640px': '95vw' };

export const SHARED_DIALOG_CONFIG = {
  modal: true,
  position: 'center',
  baseZIndex: 10000,
  autoZIndex: true,
  focusOnShow: false,
  closable: true,
  showHeader: false,
  draggable: false,
  closeOnEscape: true,
  dismissableMask: true,
} satisfies DynamicDialogConfig;

export const CONFIRMATION_SHARED_DIALOG_CONFIG = {
  ...SHARED_DIALOG_CONFIG,
  closable: true,
  width: '480px',
  breakpoints: DIALOG_BREAKPOINTS,
  focusOnShow: false,
  showHeader: true,
  closeOnEscape: true,
  dismissableMask: true,
} satisfies DynamicDialogConfig;

export const STANDARD_DIALOG_CONFIG = {
  ...SHARED_DIALOG_CONFIG,
  showHeader: true,
  focusOnShow: false,
  width: '640px',
  breakpoints: DIALOG_BREAKPOINTS,
  style: {
    minHeight: '700px',
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'column',
  },
  dismissableMask: false,
} satisfies DynamicDialogConfig;

export const SCREEN_90VW_DIALOG_CONFIG = {
  ...SHARED_DIALOG_CONFIG,
  showHeader: false,
  focusOnShow: false,
  width: '90vw',
  height: '90vh',
  dismissableMask: false,
} satisfies DynamicDialogConfig;

export const SCREEN_100VW_DIALOG_CONFIG = {
  ...SHARED_DIALOG_CONFIG,
  showHeader: false,
  focusOnShow: false,
  width: '100vw',
  height: '100vh',
  dismissableMask: false,
} satisfies DynamicDialogConfig;

export const FULL_SCREEN_DIALOG_CONFIG = {
  ...SCREEN_100VW_DIALOG_CONFIG,
  focusOnShow: false,
  style: {
    maxHeight: '100vh',
    borderRadius: '0',
  },
  contentStyle: {
    height: '100%',
  },
} satisfies DynamicDialogConfig;
